import { onboardingUrl } from './hub'

// Set when we send the user to Hub onboarding, so a user who comes back
// still not ready gets a message instead of an endless redirect loop.
const REDIRECTED_AT_KEY = 'ppce:onboardingRedirectAt'
const LOOP_WINDOW_MS = 10 * 60 * 1000

// Returns false when a redirect just happened and `force` isn't set.
export const redirectToOnboarding = ({ force = false } = {}) => {
  const redirectedAt = Number(window.sessionStorage.getItem(REDIRECTED_AT_KEY))
  if (!force && redirectedAt && Date.now() - redirectedAt < LOOP_WINDOW_MS) {
    return false
  }

  window.sessionStorage.setItem(REDIRECTED_AT_KEY, String(Date.now()))
  window.location.assign(onboardingUrl(window.location.href))
  return true
}

export const clearOnboardingRedirect = () => {
  window.sessionStorage.removeItem(REDIRECTED_AT_KEY)
}
